<mat-drawer-container class="drawer-container" style="overflow: hidden !important;">
    <div class="content">
      <app-header></app-header>
        <app-index></app-index>
      <app-footer></app-footer>  
    </div>
</mat-drawer-container>